/**
 * Sleep Assessment Quiz - Horizon Theme
 *
 * Multi-step quiz implementing:
 * - Epworth Sleepiness Scale (ESS) - Step 2
 * - STOP-BANG Questionnaire - Step 3 Option A
 * - OSA-50 Screening Questionnaire - Step 3 Option B
 * - Results & Lead Capture - Step 4
 *
 * Scoring thresholds (medical standards - do not modify):
 * - ESS >= 8: excessive daytime sleepiness
 * - STOP-BANG >= 3: Medicare subsidy eligibility
 * - OSA-50 >= 5: Medicare subsidy eligibility
 */

/**
 * PDF field mapping - maps DOM element IDs to fillable PDF form field names.
 * These field names correspond to the CPAP Referral Form PDF.
 * DO NOT modify these mappings unless the PDF form is updated.
 */
const fieldMapper = {
  step1: {
    "#s_1_row_1_rb_0": "Check Box5",
    "#s_1_row_1_rb_1": "Check Box6",
    "#s_1_row_1_rb_2": "Check Box7",
    "#s_1_row_1_rb_3": "Check Box8",
    "#s_1_row_2_rb_0": "Check Box9",
    "#s_1_row_2_rb_1": "Check Box10",
    "#s_1_row_2_rb_2": "Check Box11",
    "#s_1_row_2_rb_3": "Check Box12",
    "#s_1_row_3_rb_0": "Check Box13",
    "#s_1_row_3_rb_1": "Check Box14",
    "#s_1_row_3_rb_2": "Check Box15",
    "#s_1_row_3_rb_3": "Check Box16",
    "#s_1_row_4_rb_0": "Check Box17",
    "#s_1_row_4_rb_1": "Check Box18",
    "#s_1_row_4_rb_2": "Check Box19",
    "#s_1_row_4_rb_3": "Check Box20",
    "#s_1_row_5_rb_0": "Check Box21",
    "#s_1_row_5_rb_1": "Check Box22",
    "#s_1_row_5_rb_2": "Check Box23",
    "#s_1_row_5_rb_3": "Check Box24",
    "#s_1_row_6_rb_0": "Check Box25",
    "#s_1_row_6_rb_1": "Check Box28",
    "#s_1_row_6_rb_2": "Check Box31",
    "#s_1_row_6_rb_3": "Check Box34",
    "#s_1_row_7_rb_0": "Check Box26",
    "#s_1_row_7_rb_1": "Check Box29",
    "#s_1_row_7_rb_2": "Check Box32",
    "#s_1_row_7_rb_3": "Check Box35",
    "#s_1_row_8_rb_0": "Check Box27",
    "#s_1_row_8_rb_1": "Check Box30",
    "#s_1_row_8_rb_2": "Check Box33",
    "#s_1_row_8_rb_3": "Check Box36",
  },
  stopbang: {
    "#s_2_row_1_rb_1": "Check Box37",
    "#s_2_row_2_rb_1": "Check Box38",
    "#s_2_row_3_rb_1": "Check Box39",
    "#s_2_row_4_rb_1": "Check Box40",
    "#s_2_row_5_rb_1": "Check Box41",
    "#s_2_row_6_rb_1": "Check Box42",
    "#s_2_row_7_rb_1": "Check Box43",
    "#s_2_row_8_rb_1": "Check Box44",
    "#s_2_row_1_rb_0": "Check Box45",
    "#s_2_row_2_rb_0": "Check Box46",
    "#s_2_row_3_rb_0": "Check Box47",
    "#s_2_row_4_rb_0": "Check Box49",
    "#s_2_row_5_rb_0": "Check Box50",
    "#s_2_row_6_rb_0": "Check Box51",
    "#s_2_row_7_rb_0": "Check Box52",
    "#s_2_row_8_rb_0": "Check Box53",
  },
  osa: {
    "#s_3_row_1_rb_3": "Check Box54",
    "#s_3_row_2_rb_3": "Check Box55",
    "#s_3_row_3_rb_2": "Check Box56",
    "#s_3_row_4_rb_2": "Check Box57",
  },
  text: {
    ".step2_total": "High",
    ".step-3-total--shop_bang":
      "TOTAL SCORE Patient must score  3 for Medicare subsidy",
    ".step-3-total--osa":
      "2TOTAL SCORE Patient must score  5 for Medicare subsidy",
  },
  input: {
    "#name-feild": "First Name",
    "#phone-feild": "Tel Home",
  },
};

/**
 * SleepQuiz - Main quiz controller
 * Exposed as a global object for onclick handlers in the Liquid template.
 */
const SleepQuiz = (function () {
  "use strict";

  let initialized = false;

  /**
   * Initialize quiz event listeners and state.
   * Called automatically when the DOM is ready.
   */
  function init() {
    const quizForm = document.getElementById("quiz-form");
    if (!quizForm || initialized) return;
    initialized = true;

    // Step 2: ESS table radio change listeners
    const tableStep2 = document.getElementById("table_step_2");
    if (tableStep2) {
      tableStep2
        .querySelectorAll('input[type="radio"]')
        .forEach(function (radio) {
          radio.addEventListener("change", function () {
            updateESSScore();
          });
        });
    }

    // Step 3: Questionnaire selector listeners
    const step3Selectors = document.querySelectorAll(".step3_selector");
    step3Selectors.forEach(function (selector) {
      selector.addEventListener("change", function (e) {
        handleStep3SelectorChange(e);
      });
    });
  }

  /**
   * Calculate and display the ESS (Step 2) total score.
   * Enables the Next button when all 8 questions are answered.
   */
  function updateESSScore() {
    var tableStep2 = document.getElementById("table_step_2");
    var totalPoints = 0;
    tableStep2
      .querySelectorAll('input[type="radio"]:checked')
      .forEach(function (checked) {
        totalPoints += parseInt(checked.value);
      });

    document.querySelector(".step2_total").innerText = totalPoints;
    var resultEl = document.querySelector(".result_for_step_2");
    if (resultEl) {
      resultEl.innerHTML = totalPoints + " points";
    }

    // Enable Next button when all 8 ESS questions are answered
    if (
      tableStep2.querySelectorAll('input[type="radio"]:checked').length >= 8
    ) {
      document
        .querySelector('.quiz-form__btn[data-action="step-2"]')
        .classList.remove("disabled");
    }
  }

  /**
   * Handle Step 3 questionnaire selector change (STOP-BANG vs OSA-50).
   * Shows the selected table, hides the other, and binds score calculation.
   */
  function handleStep3SelectorChange(e) {
    var selectedValue = e.target.value;

    // Show total score container
    var totalContainer = document.getElementById("step3_total_container");
    totalContainer.classList.remove("hidden");

    // Show/hide the appropriate table
    var tables = document.querySelectorAll("table.table_step_3");
    tables.forEach(function (table) {
      if (table.classList.contains("table_step_3_" + selectedValue)) {
        table.classList.remove("hidden");
      } else {
        table.classList.add("hidden");
      }
    });

    // Disable Next button until questionnaire is complete
    document
      .querySelector('.quiz-form__btn[data-action="step-3"]')
      .classList.add("disabled");

    // Get the active table and bind radio listeners
    var table =
      selectedValue === "stop_bang"
        ? document.getElementById("stop-bang-table")
        : document.getElementById("osa-table");

    table.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      radio.addEventListener("change", function () {
        updateStep3Score(selectedValue, table);
      });
    });

    // Recalculate in case there are already checked values
    updateStep3Score(selectedValue, table);

    // Check if already complete (switching back to a completed questionnaire)
    var requiredCount = selectedValue === "stop_bang" ? 8 : 4;
    if (
      table.querySelectorAll('input[type="radio"]:checked').length >=
      requiredCount
    ) {
      document
        .querySelector('.quiz-form__btn[data-action="step-3"]')
        .classList.remove("disabled");
    }
  }

  /**
   * Calculate and display the Step 3 score for the selected questionnaire.
   */
  function updateStep3Score(selectedValue, table) {
    var totalPoints = 0;
    table
      .querySelectorAll('input[type="radio"]:checked')
      .forEach(function (checked) {
        totalPoints += parseInt(checked.value);
      });

    document.getElementById("step3_total").innerText = totalPoints;

    if (selectedValue === "stop_bang") {
      document.getElementById("result_for_step3_stop_bang").innerText =
        totalPoints + " points";
      document.getElementById("result_for_step3_osa").innerText = "N/A";

      if (
        table.querySelectorAll('input[type="radio"]:checked').length >= 8
      ) {
        document
          .querySelector('.quiz-form__btn[data-action="step-3"]')
          .classList.remove("disabled");
      }
    } else if (selectedValue === "osa") {
      document.getElementById("result_for_step3_stop_bang").innerText = "N/A";
      document.getElementById("result_for_step3_osa").innerText =
        totalPoints + " points";

      if (
        table.querySelectorAll('input[type="radio"]:checked').length >= 4
      ) {
        document
          .querySelector('.quiz-form__btn[data-action="step-3"]')
          .classList.remove("disabled");
      }
    }
  }

  /**
   * Navigate between quiz steps.
   * Updates progress indicator and manages step visibility.
   *
   * @param {number} step - The step number to navigate to (1-4).
   */
  function switchStep(step) {
    var target = document.getElementById("quiz-form");
    window.scrollTo({ top: target.offsetTop - 50, behavior: "smooth" });

    var progressEl = document.getElementById("progress");
    var dot2 = document.getElementById("progress-dot-2");
    var dot3 = document.getElementById("progress-dot-3");
    var bar2 = document.getElementById("progress-bar-2");

    // Hide all steps first
    document.querySelectorAll(".quiz-form__step").forEach(function (item) {
      item.classList.add("hidden");
    });

    if (step === 1) {
      document.getElementById("step-1").classList.remove("hidden");
      progressEl.classList.add("hidden");
    }

    if (step === 2) {
      document.getElementById("step-2").classList.remove("hidden");
      progressEl.classList.remove("hidden");
      window.Shopify?.analytics?.publish('custom_quiz_start');

      // Progress: dot 2 active, dot 3 default
      dot2.className = "quiz-form__progress-dot is-active";
      bar2.className = "quiz-form__progress-bar";
      dot3.className = "quiz-form__progress-dot";
    }

    if (step === 3) {
      // If ESS score < 8, skip to results as ineligible
      var essScore = parseInt(
        document.querySelector(".step2_total").textContent
      );
      if (essScore < 8) {
        switchStep(4);
        return;
      }

      document.getElementById("step-3").classList.remove("hidden");
      progressEl.classList.remove("hidden");

      // Progress: dot 2 complete, dot 3 active
      dot2.className = "quiz-form__progress-dot is-complete";
      bar2.className = "quiz-form__progress-bar is-active";
      dot3.className = "quiz-form__progress-dot is-active";
    }

    if (step === 4) {
      document.getElementById("step-4").classList.remove("hidden");
      progressEl.classList.add("hidden");

      // Progress: both complete
      dot2.className = "quiz-form__progress-dot is-complete";
      bar2.className = "quiz-form__progress-bar is-active";
      dot3.className = "quiz-form__progress-dot is-complete";

      // Determine eligibility
      var essTotal = parseInt(
        document.querySelector(".step2_total").innerText
      );
      var step3SelectorValue = document.querySelector(
        ".step3_selector:checked"
      )?.value;

      var stopBangScore = parseInt(
        document.getElementById("result_for_step3_stop_bang").innerText
      ) || 0;
      var osaScore = parseInt(
        document.getElementById("result_for_step3_osa").innerText
      ) || 0;

      var isEligible =
        essTotal >= 8 &&
        ((stopBangScore >= 3 && step3SelectorValue === "stop_bang") ||
          (osaScore >= 5 && step3SelectorValue === "osa"));

      // Update result card
      var resultCard = document.getElementById("result-card");
      var resultStatus = document.getElementById("result-status");
      var sleepStudyLink = document.getElementById("sleep-study-link");
      var leadFormHeading = document.getElementById("lead-form-heading");
      var footerEligible = document.getElementById("footer-eligible");
      var footerIneligible = document.getElementById("footer-ineligible");

      resultCard.classList.remove("is-eligible", "is-ineligible");

      window.Shopify?.analytics?.publish('custom_quiz_complete', {
        ess_score: essTotal,
        stop_bang_score: stopBangScore,
        osa_score: osaScore,
        questionnaire_type: step3SelectorValue || 'none',
        is_eligible: isEligible,
        risk_level: isEligible ? 'high' : 'low',
      });

      if (isEligible) {
        resultCard.classList.add("is-eligible");
        resultStatus.innerText = "You may be eligible for a Sleep Study";
        sleepStudyLink.classList.remove("hidden");
        leadFormHeading.innerText = "Email me the referral form";
        footerEligible.classList.remove("hidden");
        footerIneligible.classList.add("hidden");
      } else {
        resultCard.classList.add("is-ineligible");
        resultStatus.innerText =
          "Based on your answers, a sleep study might not be the best option";
        sleepStudyLink.classList.add("hidden");
        leadFormHeading.innerText = "Request a consultation";
        footerEligible.classList.add("hidden");
        footerIneligible.classList.remove("hidden");
      }
    }
  }

  /**
   * Handle lead capture form submission.
   * Collects quiz answers and submits to external API.
   *
   * @param {Event} e - Form submit event.
   * @returns {boolean} false to prevent default form submission.
   */
  async function handleFormSubmit(e) {
    e.preventDefault();
    var form = document.getElementById("info-form");

    var step3SelectorValue = document.querySelector(
      ".step3_selector:checked"
    )?.value;

    var stopBangScore = parseInt(
      document.getElementById("result_for_step3_stop_bang").innerText
    ) || 0;
    var osaScore = parseInt(
      document.getElementById("result_for_step3_osa").innerText
    ) || 0;

    var isEligible =
      parseInt(document.querySelector(".step2_total").innerText) >= 8 &&
      ((stopBangScore >= 3 && step3SelectorValue === "stop_bang") ||
        (osaScore >= 5 && step3SelectorValue === "osa"));

    var fields = getAssessmentResult();

    var payload = {
      platform: "cpap",
      email: form.querySelector('[name="email"]').value,
      firstName: form.querySelector('[name="firstName"]').value,
      lastName: form.querySelector('[name="lastName"]').value,
      phone: form.querySelector('[name="phone"]').value,
      adminEmail: form.querySelector('[name="adminEmail"]').value,
      senderEmail: form.querySelector('[name="senderEmail"]').value,
      fields: fields,
      success: isEligible,
    };

    await fetch("https://e9-utilities.vercel.app/api/assessment-result", {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    // Clear form fields
    form.querySelector('[name="email"]').value = "";
    form.querySelector('[name="firstName"]').value = "";
    form.querySelector('[name="phone"]').value = "";
    form.querySelector('[name="lastName"]').value = "";

    // Show success message
    document
      .getElementById("form-success-message")
      .classList.remove("hidden");

    window.Shopify?.analytics?.publish('custom_quiz_lead_submit', {
      is_eligible: isEligible,
    });

    return false;
  }

  /**
   * Collect all quiz answers into an array for the API payload and PDF mapping.
   *
   * @returns {Array<{field: string, value: (boolean|string), type: string}>}
   */
  function getAssessmentResult() {
    var step3SelectorValue = document.querySelector(
      ".step3_selector:checked"
    )?.value;
    var stopBangTotal = document.getElementById("result_for_step3_stop_bang")?.innerText || "N/A";
    var osaTotal = document.getElementById("result_for_step3_osa")?.innerText || "N/A";
    var isStopbang =
      step3SelectorValue === "stop_bang" && stopBangTotal !== "N/A" && stopBangTotal !== "0";
    var isOsa =
      step3SelectorValue === "osa" && osaTotal !== "N/A" && osaTotal !== "0";

    var payload = [];

    // Step 1 (ESS) checkboxes
    Object.keys(fieldMapper.step1).forEach(function (key) {
      var el = document.querySelector(key);
      if (el && el.checked) {
        payload.push({
          field: fieldMapper.step1[key],
          value: true,
          type: "checkbox",
        });
      }
    });

    // ESS total score
    payload.push({
      field: "High",
      value: document.querySelector(".step2_total").innerText,
      type: "text",
    });

    // STOP-BANG checkboxes and total
    if (isStopbang) {
      Object.keys(fieldMapper.stopbang).forEach(function (key) {
        var el = document.querySelector(key);
        if (el && el.checked) {
          payload.push({
            field: fieldMapper.stopbang[key],
            value: true,
            type: "checkbox",
          });
        }
      });
      var sbTotalEl = document.querySelector(".step-3-total--shop_bang");
      if (sbTotalEl) {
        payload.push({
          field:
            "TOTAL SCORE Patient must score  3 for Medicare subsidy",
          value: sbTotalEl.innerText,
          type: "text",
        });
      }
    }

    // OSA-50 checkboxes and total
    if (isOsa) {
      Object.keys(fieldMapper.osa).forEach(function (key) {
        var el = document.querySelector(key);
        if (el && el.checked) {
          payload.push({
            field: fieldMapper.osa[key],
            value: true,
            type: "checkbox",
          });
        }
      });
      var osaTotalEl = document.querySelector(".step-3-total--osa");
      if (osaTotalEl) {
        payload.push({
          field:
            "2TOTAL SCORE Patient must score  5 for Medicare subsidy",
          value: osaTotalEl.innerText,
          type: "text",
        });
      }
    }

    return payload;
  }

  /**
   * Generate a filled PDF with quiz answers and trigger download.
   * Uses pdf-lib to fill form fields in the CPAP Referral Form PDF.
   */
  async function handleFillablePDF() {
    var step3SelectorValue = document.querySelector(
      ".step3_selector:checked"
    )?.value;
    var sbTotalEl = document.querySelector(".step-3-total--shop_bang");
    var osaTotalEl = document.querySelector(".step-3-total--osa");
    var isStopbang =
      step3SelectorValue === "stop_bang" &&
      sbTotalEl && sbTotalEl.innerText !== "0";
    var isOsa =
      step3SelectorValue === "osa" &&
      osaTotalEl && osaTotalEl.innerText !== "0";

    // Get the PDF URL from the data attribute on the quiz container
    var quizEl = document.getElementById("quiz-form");
    var formUrl =
      quizEl.getAttribute("data-referral-pdf-url") ||
      "https://cdn.shopify.com/s/files/1/0622/9511/3954/files/CPAP-Referral-form-FILLABLE.pdf";

    var formPdfBytes = await fetch(formUrl).then(function (res) {
      return res.arrayBuffer();
    });
    var PDFDocument = PDFLib.PDFDocument;
    var pdfDoc = await PDFDocument.load(formPdfBytes);
    var form = pdfDoc.getForm();

    // Fill ESS (Step 1) checkboxes
    Object.keys(fieldMapper.step1).forEach(function (key) {
      var field = form.getField(fieldMapper.step1[key]);
      if (document.querySelector(key).checked) {
        field.check();
      }
    });

    // Fill ESS total score
    var essField = form.getField("High");
    var essTotal = document.querySelector(".step2_total");
    if (essTotal) {
      essField.setText(essTotal.innerText);
    }

    // Fill STOP-BANG fields
    if (isStopbang) {
      Object.keys(fieldMapper.stopbang).forEach(function (key) {
        var field = form.getField(fieldMapper.stopbang[key]);
        if (document.querySelector(key).checked) {
          field.check();
        }
      });
      var sbField = form.getField(
        "TOTAL SCORE Patient must score  3 for Medicare subsidy"
      );
      if (sbTotalEl) {
        sbField.setText(sbTotalEl.innerText);
      }
    }

    // Fill OSA-50 fields
    if (isOsa) {
      Object.keys(fieldMapper.osa).forEach(function (key) {
        var field = form.getField(fieldMapper.osa[key]);
        if (document.querySelector(key).checked) {
          field.check();
        }
      });
      var osaField = form.getField(
        "2TOTAL SCORE Patient must score  5 for Medicare subsidy"
      );
      if (osaTotalEl) {
        osaField.setText(osaTotalEl.innerText);
      }
    }

    var pdfBytes = await pdfDoc.save();
    window.Shopify?.analytics?.publish('custom_quiz_pdf_download');
    download(pdfBytes, "Assessment_Result.pdf", "application/pdf");
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Public API
  return {
    switchStep: switchStep,
    handleFormSubmit: handleFormSubmit,
    handleFillablePDF: handleFillablePDF,
  };
})();
